var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.476209 4.28583H9.97597L6.33835 0.821069C6.14787 0.63964 6.14049 0.338211 6.32192 0.147735C6.50311 -0.0425029 6.80454 -0.050122 6.99526 0.131307L11.1495 4.08845C11.3293 4.26845 11.4286 4.5075 11.4286 4.76202C11.4286 5.01631 11.3293 5.25559 11.1412 5.44345L6.99502 9.3925C6.90287 9.48036 6.78478 9.52393 6.66668 9.52393C6.54097 9.52393 6.41526 9.4744 6.32168 9.37607C6.14026 9.18559 6.14764 8.8844 6.33811 8.70297L9.99097 5.23821H0.476209C0.213351 5.23821 1.81198e-05 5.02488 1.81198e-05 4.76202C1.81198e-05 4.49916 0.213351 4.28583 0.476209 4.28583Z",
    fill: "#50D5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.4c2dab85d264ec44cda2dcdd43efae53.svg";
export { ForwardRef as ReactComponent };